import { useEffect, useRef } from 'react'
import { animateCheckmarkBounceIn } from './booksQuestionAnimations'

export const useCheckmarkBounceAnimation = (isVisible: boolean) => {
  const checkIconRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isVisible) return undefined
    const tween = animateCheckmarkBounceIn(checkIconRef.current)
    return () => {
      tween?.kill()
    }
  }, [isVisible])

  return { checkIconRef }
}
